<template>
  <a-modal
    :visible="visible"
    :title="`Asignar campañas y colas - Plantilla “${wppTemplate.name}”`"
    :keyboard="false"
    centered
    :width="560"
    :mask-closable="false"
    @cancel="handleClose"
  >
    <section>
      <h3>Selecciona las campañas y colas que deseas asociar a tu plantilla</h3>

      <a-form class="form" :model="formState" layout="vertical">
        <CampaignPicker
          v-model:value="formState.portfolio"
          withName
          withOutEntity
          multiple
          :showAll="false"
          label="Campaña"
        />

        <QueuePicker
          v-model:value="formState.queue"
          label="Cola"
          multiple
          :showAll="false"
          :withOutPortfolio="false"
          :portfolio="formState.portfolio"
        />
      </a-form>

      <p class="info">
        <strong>Nota: </strong> Encontrarás esta plantilla cada vez que selecciones las colas o
        campañas configuradas, o cuando un contacto llegue a través de estas.
      </p>
    </section>

    <template #footer>
      <a-button @click="handleClose"> Cancelar </a-button>

      <a-button type="primary" :disabled="isDisabled" :loading="loading" @click="handleSave">
        Guardar cambios
      </a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { message } from "ant-design-vue";
import { computed, reactive, readonly, ref } from "vue";
import { isEqual, cloneDeep } from "lodash";

import { updateTemplate } from "@/app/channels/services";
import { ResponseError } from "@/app/shared/utils/httpManager";

import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import QueuePicker from "@/app/shared/components/pickers/QueuePicker.vue";

const props = defineProps({
  visible: Boolean,
  wppTemplate: Object,
});

const emit = defineEmits(["update:visible", "update"]);

const formState = reactive({
  portfolio: [...new Set(props.wppTemplate?.queues?.map((q) => q?.portfolios?.[0]?.id))],
  queue: props.wppTemplate?.queues?.map((q) => q.id),
});

const comparativeForm = readonly(cloneDeep(formState));

const loading = ref(false);
const isDisabled = computed(() => isEqual(comparativeForm.queue, formState.queue));

const handleSave = async () => {
  loading.value = true;

  try {
    const body = { queues: formState.queue };
    await updateTemplate({ templateId: props.wppTemplate.id, body });

    message.success("Se actualizó la plantilla");
    emit("update");
    handleClose();
  } catch (error) {
    const errorMessage =
      error instanceof ResponseError ? error.getErrorMessage() : "Ha ocurrido un error";

    message.error(errorMessage);
  }

  loading.value = false;
};

const handleClose = () => emit("update:visible", false);
</script>

<style scoped lang="sass">
section
  margin: 0 3rem 5rem

h3
  color: $gray-9
  font-weight: 600
  font-size: 16px
  margin-bottom: 24px

.form
  margin-bottom: 24px

.info
  color: $gray-8
</style>
